import Head from "next/head"

const Favicon = () => {
	return (
		<Head>
			<link
				rel="apple-touch-icon"
				sizes="180x180"
				href="/apple-touch-icon.png"
			/>
			<link
				rel="icon"
				type="image/png"
				sizes="32x32"
				href="/favicon-32x32.png"
			/>
			<link
				rel="icon"
				type="image/png"
				sizes="16x16"
				href="/favicon-16x16.png"
			/>
			<link rel="manifest" href="/site.webmanifest" />
			<meta name="theme-color" content="#121212" />
			<meta
				name="msapplication-TileColor"
				content="#ecedef"
			/>

			<link href="/favicon.svg" rel="icon" />
		</Head>
	)
}

export default Favicon
